//
// Javascript for the ColorPicker control
//
//  Ben Ramey
//  May 2010
//
HEIJS.registerNamespace("HEIJS.Controls.jQuery");
HEIJS.Controls.jQuery.ColorPickerManager = function()
{
  var self = this;
  this.picker = $("div.hei-colorpicker-flat:first");

  if (this.picker.length <= 0)
  {
    return;
  }

  this.picker
    .appendTo("body")
    .ColorPicker({
      flat: true,
      onSubmit: function(hsb, hex, rgb, el)
      {
        self.handlePickerSubmit(hsb, hex, rgb);
        $(el).hide();
        self.unbindDocumentClick();
      },
      onChange: function(hsb, hex, rbg)
      {
        self.handlePickerChange(hsb, hex, rbg);
      }
    });
};

HEIJS.Controls.jQuery.ColorPickerManager.prototype =
{
  //
  // Properties
  //
  picker: null,
  pickerOnSubmitDelegate: function() { },
  pickerOnChangeDelegate: function() { },
  pickerGetValueDelegate: function() { return "ffffff"; },

  //
  // Methods
  //
  show: function(elementToShowAt, submitDelegate, changeDelegate, valueDelegate)
  {
    if (this.picker.is(":visible"))
    {
      this.hide();
    }

    this.pickerOnSubmitDelegate = submitDelegate;
    this.pickerOnChangeDelegate = changeDelegate;
    this.pickerGetValueDelegate = valueDelegate;

    var elementToShowAtOffset = elementToShowAt.offset();
    var top = elementToShowAtOffset.top + elementToShowAt.height();
    var left = elementToShowAtOffset.left;

    this.picker.ColorPickerSetColor(this.handleGetValue());
    this.picker
      .css({
        "top": top,
        "left": left
      })
      .show();

    if ((left + this.picker.outerWidth()) > $("body").width())
    {
      left = elementToShowAtOffset.left - this.picker.outerWidth() + elementToShowAt.outerWidth();
      this.picker.css("left", left);
    }

    if ((top + this.picker.height()) > $("body").height())
    {
      top = elementToShowAtOffset.top - this.picker.outerHeight();
      this.picker.css("top", top);
    }

    var self = this;
    setTimeout(
      function()
      {
        $(document).bind("click.colorpicker", function(e) { self.handleDocumentClick(e); });
        $("iframe").each(function()
        {
          try
          {
            $(this.contentWindow.document).bind("click.colorpicker", function(e) { self.handleDocumentClick(e); });
          }
          catch (e) { }
        });
      },
      100
    );
  },

  handleDocumentClick: function(e)
  {
    var target = $(e.target);
    var selector = "div.colorpicker, div.hei-colorpicker-selector";

    if (!target.is(selector)
          && target.parents(selector).length == 0)
    {
      this.hide();
    }
  },

  hide: function()
  {
    this.picker.find("div.colorpicker_submit").trigger("click");
  },

  rgbToHex: function(rgb)
  {
    var char = "0123456789ABCDEF";
    return String(char.charAt(Math.floor(rgb / 16))) + String(char.charAt(rgb - (Math.floor(rgb / 16) * 16)));
  },

  hexToRgb: function(hex)
  {
    var rgb = { r: null, g: null, b: null };
    hex = (hex.charAt(0) == "#") ? hex.substring(1, 7) : hex;

    rgb.r = parseInt(hex.substring(0, 2), 16);
    rgb.g = parseInt(hex.substring(2, 4), 16);
    rgb.b = parseInt(hex.substring(4, 6), 16);

    return rgb;
  },

  hexToHsb: function(hex)
  {
    var rgb = this.hexToRgb(hex);
    return this.rgbToHsb(rgb.r, rgb.g, rgb.b);
  },

  // http://www.actionscript.org/forums/showthread.php3?t=15155
  hsbToRgb: function(hue, sat, val)
  {
    var red, grn, blu, i, f, p, q, t;
    hue %= 360;
    if (val == 0) { return ({ r: 0, g: 0, v: 0 }); }
    sat /= 100;
    val /= 100;
    hue /= 60;
    i = Math.floor(hue);
    f = hue - i;
    p = val * (1 - sat);
    q = val * (1 - (sat * f));
    t = val * (1 - (sat * (1 - f)));
    if (i == 0) { red = val; grn = t; blu = p; }
    else if (i == 1) { red = q; grn = val; blu = p; }
    else if (i == 2) { red = p; grn = val; blu = t; }
    else if (i == 3) { red = p; grn = q; blu = val; }
    else if (i == 4) { red = t; grn = p; blu = val; }
    else if (i == 5) { red = val; grn = p; blu = q; }
    red = Math.floor(red * 255);
    grn = Math.floor(grn * 255);
    blu = Math.floor(blu * 255);
    return ({ r: red, g: grn, b: blu });
  },

  // http://www.actionscript.org/forums/showthread.php3?t=15155
  rgbToHsb: function(red, grn, blu)
  {
    var x, val, f, i, hue, sat, val;
    red /= 255;
    grn /= 255;
    blu /= 255;
    x = Math.min(Math.min(red, grn), blu);
    val = Math.max(Math.max(red, grn), blu);
    if (x == val)
    {
      return ({ h: undefined, s: 0, v: val * 100 });
    }
    f = (red == x) ? grn - blu : ((grn == x) ? blu - red : red - grn);
    i = (red == x) ? 3 : ((grn == x) ? 5 : 1);
    hue = Math.floor((i - f / (val - x)) * 60) % 360;
    sat = Math.floor(((val - x) / val) * 100);
    val = Math.floor(val * 100);
    return ({ h: hue, s: sat, b: val });
  },

  unbindDocumentClick: function()
  {
    $(document).unbind("click.colorpicker");
    $("iframe").each(function()
    {
      try
      {
        $(this.contentWindow.document).unbind("click.colorpicker");
      }
      catch (e) { }
    });
  },

  handlePickerSubmit: function(hsb, hex, rgb)
  {
    if ($.isFunction(this.pickerOnSubmitDelegate))
    {
      (this.pickerOnSubmitDelegate).call(this, hsb, hex, rgb);
    }
  },

  handlePickerChange: function(hsb, hex, rgb)
  {
    if ($.isFunction(this.pickerOnChangeDelegate))
    {
      (this.pickerOnChangeDelegate).call(this, hsb, hex, rgb);
    }
  },

  handleGetValue: function()
  {
    if ($.isFunction(this.pickerGetValueDelegate))
    {
      var color = (this.pickerGetValueDelegate).call(this);
      var hexColor = color;
      if (/^rgb/.test(color))
      {
        var rgbValues = color.match(/\d+/g);
        for (var idx = 0; idx < rgbValues.length; idx++)
        {
          rgbValues[idx] = this.rgbToHex(rgbValues[idx]);
        }
        hexColor = rgbValues.join("");
      }

      return hexColor;
    }
  }
};

$(document).ready(
  function()
  {
    HEIJS.page.colorPickerManager = new HEIJS.Controls.jQuery.ColorPickerManager();
  }
);